export enum IAppearanceFormNames {
	surveyInterface = 'surveyInterface',
	questionId = 'questionId',
	surveyRoles = 'surveyRoles',
}

export interface ISlidersLevel {
	firstLevel: string;
	secondLevel: string;
	thirdLevel: string;
}

export enum IWorkStyleTypes {
	technical = 'technical',
	collaborative = 'collaborative',
	mobility = 'mobility',
}

export enum IExtremesSliderNames {
	workStyleFirstSlider = 'workStyleFirstSlider',
	workStyleSecondSlider = 'workStyleSecondSlider',
	workStyleThirdSlider = 'workStyleThirdSlider',
	performanceFirstSlider = 'performanceFirstSlider',
	performanceSecondSlider = 'performanceSecondSlider',
	performanceThirdSlider = 'performanceThirdSlider',
}

export interface IAppearanceForm extends Record<string, any> {
	[IAppearanceFormNames.surveyInterface]: ISurveyInterfaceTypes;
	[IAppearanceFormNames.surveyRoles]: number[];
	[IAppearanceFormNames.questionId]: number;
	[IExtremesSliderNames.workStyleFirstSlider]: string;
	[IExtremesSliderNames.workStyleSecondSlider]: string;
	[IExtremesSliderNames.workStyleThirdSlider]: string;
	[IExtremesSliderNames.performanceFirstSlider]: string;
	[IExtremesSliderNames.performanceSecondSlider]: string;
	[IExtremesSliderNames.performanceThirdSlider]: string;
}

export enum ISurveyInterfaceTypes {
	chatBot = 'CHAT_BOT',
	classical = 'CLASSICAL_MODE',
}
